import { createContext, useContext, useState } from "react";
import { retrieveTokens } from "$api/tokenManagement";
import { login as loginFunc, logout as logoutFunc } from "$api/authentication";
import { App } from "antd";
import { AxiosError } from "axios";
import { useNavigate } from "react-router";
import { configureClient } from "$api/client";
import { parseJwt, storeTokens } from "$api/tokenManagement";
import { parseMunicipalUtilityId } from "../api/tokenManagement";

const defaultAuthContextValues = {
  isAuthenticated: false,
  isAdmin: false,
  municipal: null,
  bearerToken: "",
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
};

export const AuthContext = createContext(defaultAuthContextValues);

export const useAuth = () => useContext(AuthContext);

const {
  bearerToken: storedBearerToken,
  username: storedUsername,
  municipal: storedMunicipal,
} = retrieveTokens() || {};

const AuthContextProvider = (props) => {
  const [bearerToken, setBearerToken] = useState(storedBearerToken);
  const [usedUsername, setUsedUsername] = useState(storedUsername);
  const [municipalUtility, setMunicipalUtility] = useState(storedMunicipal);
  const isAuthenticated = !!bearerToken;
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const { notification } = App.useApp();
  const openErrorNotification = (title) => {
    notification.error({
      message: title,
    });
  };

  const login = async (creadentials) => {
    let token;
    try {
      token = await loginFunc(creadentials);
    } catch (err) {
      if (err instanceof AxiosError && err.response) {
        if (err.response.status === 401) {
          openErrorNotification(err.response.data.detail);
        } else {
          openErrorNotification("Login failed!");
        }
      }
    }

    const { sub: usernameFromToken, scopes } = parseJwt(token.access_token);
    const municipal = parseMunicipalUtilityId(scopes[0]);
    setUsedUsername(usernameFromToken);

    setIsAdmin(token.is_admin);
    setBearerToken(token.access_token);
    storeTokens(token.access_token);
    setMunicipalUtility(municipal);
    navigate("/");
  };

  const logout = () => {
    setBearerToken("");
    setIsAdmin("");
    const rootPath = "/login";
    logoutFunc();
    navigate(rootPath);
  };

  if (isAuthenticated) {
    configureClient(process.env.REACT_APP_API_URL);
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isAdmin,
        bearerToken,
        municipalUtility,
        login,
        logout,
        usedUsername,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContextProvider;
